module.exports = __webpack_public_path__ + "static/media/sameer_jagruti_yatra.6f5e2717.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sameer_jagruti_yatra.webp
// module id = 323
// module chunks = 0